module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABGSURBVChTY1D2mO+QuAYPAipgcExcs/3o/e4FZ7AioBRQAUhR14IzMk5zsCKgzlFFsCDYdvQ+MKiwImhgAkMdGFx4EFABAHcgvwrWPy8IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/img/icons/public_transport_stops/Reiner_BP.png
// module id = 154
// module chunks = 0 2